"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentDayChangePermissionValidation = void 0;
const journey_services_1 = require("@athena-portal/journey-services");
const moment_1 = __importDefault(require("moment"));
class PaymentDayChangePermissionValidation extends journey_services_1.ValidationMethodBase {
    validateInput(input, context) {
        const pageContext = context;
        if (pageContext.engine) {
            const interaction = pageContext.engine.getInteraction();
            if (interaction.paymentDay.currentDay.toString() === interaction.paymentDay.day) {
                const error = this.getErrorMessage(context, "Selected day of the month already is your subscription payment day.");
                return this.invalidResult(error);
            }
            if (interaction.paymentDay.subscriptionStatus === 'MTC') {
                const error = this.getErrorMessage(context, "Your subscription is due to be cancelled soon.");
                return this.invalidResult(error);
            }
            if (!interaction.paymentDay.subscriptionStatus) {
                const error = this.getErrorMessage(context, "No active subscription.");
                return this.invalidResult(error);
            }
            if (interaction.paymentDay.renewalWindowEndDate) {
                const formattedDate = moment_1.default.utc(interaction.paymentDay.renewalWindowEndDate).format("D MMMM YYYY");
                const error = this.getErrorMessage(context, "Your current subscription is getting renewed. Please come back on " + formattedDate + ".");
                return this.invalidResult(error);
            }
            if (interaction.paymentDay.currentDate) {
                const restrictionEndDate = (0, moment_1.default)(interaction.paymentDay.currentDate).add(6, 'M');
                const now = (0, moment_1.default)();
                if (now.isBefore(restrictionEndDate)) {
                    const formattedRestrictionEndDate = restrictionEndDate.format("D MMMM YYYY");
                    const error = this.getErrorMessage(context, "You're allowed to change payment day once in 6 months. Please come back on " + formattedRestrictionEndDate + ".");
                    return this.invalidResult(error);
                }
            }
        }
        return this.validResult();
    }
}
exports.PaymentDayChangePermissionValidation = PaymentDayChangePermissionValidation;
//# sourceMappingURL=PaymentDayChangePermissionValidation.js.map